/* Bathistoxastos — κίνηση και μικρο-αλληλεπιδράσεις (bx-*)
   Χωρίς βιβλιοθήκες. Σέβεται το prefers-reduced-motion.
   Χωρίς JS όλο το περιεχόμενο φαίνεται κανονικά. */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  doc.classList.add('bx-fx');
  if (reduce) doc.classList.add('bx-reduce');

  var GLYPHS = 'ΑΒΓΔΕΖΗΘΚΛΜΝΞΠΡΣΤΦΧΨΩ▪□■01';

  /* ---------- Scramble: τα γράμματα «αποκωδικοποιούνται» ---------- */
  function scramble(el, finalText, duration) {
    if (reduce) { el.textContent = finalText; return; }
    var start = null;
    var len = finalText.length;
    duration = duration || 700;
    function frame(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / duration, 1);
      var settled = Math.floor(p * len);
      var out = '';
      for (var i = 0; i < len; i++) {
        var ch = finalText[i];
        if (i < settled || ch === ' ' || ch === '·') out += ch;
        else out += GLYPHS[(Math.random() * GLYPHS.length) | 0];
      }
      el.textContent = out;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = finalText;
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Odometer: ψηφία που κυλάνε ---------- */
  function buildOdometer(el) {
    var value = el.getAttribute('data-bx-count') || el.textContent;
    el.setAttribute('aria-label', value + (el.getAttribute('data-suffix') || ''));
    el.textContent = '';
    var wrap = document.createElement('span');
    wrap.className = 'bx-odo';
    wrap.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < value.length; i++) {
      var ch = value[i];
      if (/\d/.test(ch)) {
        var col = document.createElement('span');
        col.className = 'bx-odo__col';
        var strip = document.createElement('span');
        strip.className = 'bx-odo__strip';
        for (var d = 0; d <= 9; d++) {
          var s = document.createElement('span');
          s.textContent = d;
          strip.appendChild(s);
        }
        strip.dataset.digit = ch;
        strip.style.transitionDelay = (i * 90) + 'ms';
        col.appendChild(strip);
        wrap.appendChild(col);
      } else {
        var sep = document.createElement('span');
        sep.className = 'bx-odo__sep';
        sep.textContent = ch;
        wrap.appendChild(sep);
      }
    }
    var suffix = el.getAttribute('data-suffix');
    if (suffix) {
      var sx = document.createElement('span');
      sx.className = 'bx-odo__sep';
      sx.textContent = suffix;
      wrap.appendChild(sx);
    }
    el.appendChild(wrap);
  }
  function runOdometer(el) {
    el.querySelectorAll('.bx-odo__strip').forEach(function (strip) {
      strip.style.transform = 'translateY(-' + (Number(strip.dataset.digit) * 10) + '%)';
    });
  }

  /* ---------- Reveal κατά το scroll ---------- */
  function onReveal(el) {
    el.classList.add('is-in');
    if (el.hasAttribute('data-bx-scramble')) scramble(el, el.getAttribute('data-bx-text') || el.textContent);
    if (el.hasAttribute('data-bx-count')) runOdometer(el);
  }

  function initReveal(root) {
    var els = root.querySelectorAll('[data-bx-reveal], [data-bx-scramble], [data-bx-count]');
    els.forEach(function (el) {
      if (el.dataset.bxInit) return;
      el.dataset.bxInit = '1';
      if (el.hasAttribute('data-bx-scramble')) el.setAttribute('data-bx-text', el.textContent.trim());
      if (el.hasAttribute('data-bx-count')) buildOdometer(el);
    });
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(onReveal);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { onReveal(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Hero: λέξη που αλλάζει ---------- */
  function initRotator(root) {
    root.querySelectorAll('[data-bx-rotate]').forEach(function (el) {
      var words = (el.getAttribute('data-bx-rotate') || '').split('|').map(function (w) { return w.trim(); }).filter(Boolean);
      if (words.length < 2 || reduce) return;
      var i = 0;
      setInterval(function () {
        if (document.hidden) return;
        i = (i + 1) % words.length;
        scramble(el, words[i], 520);
      }, 2600);
    });
  }

  /* ---------- Hero: 3D κλίση εξωφύλλων με το ποντίκι ---------- */
  function initTilt(root) {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    root.querySelectorAll('[data-bx-tilt]').forEach(function (stage) {
      var host = stage.closest('section') || stage;
      var raf = null;
      host.addEventListener('pointermove', function (e) {
        var r = host.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          stage.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg');
          stage.style.setProperty('--rx', (y * -10).toFixed(2) + 'deg');
        });
      });
      host.addEventListener('pointerleave', function () {
        stage.style.setProperty('--ry', '0deg');
        stage.style.setProperty('--rx', '0deg');
      });
    });
  }

  /* ---------- Finder: chips σαν συνομιλία ---------- */
  function initFinder(root) {
    root.querySelectorAll('[data-bx-finder]').forEach(function (finder) {
      var chips = Array.prototype.slice.call(finder.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(finder.querySelectorAll('[role="tabpanel"]'));
      if (!chips.length) return;
      finder.classList.add('is-ready');

      function select(chip, focus) {
        chips.forEach(function (c) {
          var on = c === chip;
          c.setAttribute('aria-selected', on ? 'true' : 'false');
          c.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p) {
          var on = p.id === chip.getAttribute('aria-controls');
          p.classList.toggle('is-active', on);
          p.hidden = !on;
          if (on) {
            p.classList.remove('is-typing');
            if (!reduce) {
              void p.offsetWidth;
              p.classList.add('is-typing');
              setTimeout(function () { p.classList.remove('is-typing'); }, 650);
            }
          }
        });
        if (focus) chip.focus();
      }

      chips.forEach(function (chip, idx) {
        chip.addEventListener('click', function () {
          select(chip, false);
          if (window.innerWidth < 750) {
            var panel = document.getElementById(chip.getAttribute('aria-controls'));
            if (panel) panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          }
        });
        chip.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = chips[(idx + 1) % chips.length];
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = chips[(idx - 1 + chips.length) % chips.length];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
      panels.forEach(function (p, i) { p.hidden = i !== 0; p.classList.toggle('is-active', i === 0); });
      chips.forEach(function (c, i) { c.setAttribute('aria-selected', i === 0 ? 'true' : 'false'); c.tabIndex = i === 0 ? 0 : -1; });
    });
  }

  /* ---------- Coverflow πακέτων ---------- */
  function initFlow(root) {
    root.querySelectorAll('[data-bx-flow]').forEach(function (flow) {
      var track = flow.querySelector('.bx-flow__track');
      var items = Array.prototype.slice.call(flow.querySelectorAll('.bx-flow__item'));
      var counter = flow.querySelector('[data-bx-flow-count]');
      var prev = flow.querySelector('[data-bx-flow-prev]');
      var next = flow.querySelector('[data-bx-flow-next]');
      if (!track || !items.length) return;
      var active = 0;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function update() {
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestD = Infinity;
        items.forEach(function (it, i) {
          var c = it.offsetLeft + it.offsetWidth / 2;
          var d = Math.abs(c - center);
          if (d < bestD) { bestD = d; best = i; }
        });
        active = best;
        items.forEach(function (it, i) {
          it.classList.toggle('is-active', i === best);
          it.classList.toggle('is-left', i < best);
          it.classList.toggle('is-right', i > best);
          it.setAttribute('aria-hidden', i === best ? 'false' : 'true');
          it.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = i === best ? 0 : -1; });
        });
        if (counter) counter.textContent = pad(best + 1) + ' / ' + pad(items.length);
        if (prev) prev.disabled = best === 0;
        if (next) next.disabled = best === items.length - 1;
      }
      function go(i) {
        i = Math.max(0, Math.min(items.length - 1, i));
        var it = items[i];
        track.scrollTo({ left: it.offsetLeft - (track.clientWidth - it.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      var t = null;
      track.addEventListener('scroll', function () { if (t) cancelAnimationFrame(t); t = requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      if (prev) prev.addEventListener('click', function () { go(active - 1); });
      if (next) next.addEventListener('click', function () { go(active + 1); });
      items.forEach(function (it, i) {
        it.addEventListener('click', function (e) {
          if (i !== active) { e.preventDefault(); go(i); }
        });
      });
      update();
    });
  }

  /* ---------- Προσθήκη στο καλάθι χωρίς αλλαγή σελίδας (Dawn cart drawer) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-bx-add]');
    if (!form) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
    fd.append('sections_url', window.location.pathname);
    if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
    var url = (window.routes && window.routes.cart_add_url) || form.getAttribute('action');
    fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'cart error');
        drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          btn.innerHTML = 'Προστέθηκε ✓';
          setTimeout(function () { btn.innerHTML = label; btn.classList.remove('is-done'); btn.disabled = false; btn.removeAttribute('aria-busy'); }, 2200);
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        form.removeAttribute('data-bx-add');
        form.submit();
      });
  });

  /* ---------- Sticky «Στο καλάθι» στη σελίδα προϊόντος ---------- */
  function initStickyAtc(root) {
    var bar = root.querySelector('[data-bx-satc]');
    if (!bar) return;
    var mainBtn = document.querySelector('product-form form [type="submit"][name="add"], product-form [type="submit"]');
    var barBtn = bar.querySelector('[data-bx-satc-btn]');
    if (!mainBtn || !barBtn) { bar.remove(); return; }
    if (mainBtn.disabled) { barBtn.disabled = true; barBtn.textContent = 'Μη διαθέσιμο'; }
    barBtn.addEventListener('click', function () { mainBtn.click(); });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        barBtn.tabIndex = past ? 0 : -1;
      });
    });
    io.observe(mainBtn);
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initRotator(root);
    initTilt(root);
    initFinder(root);
    initFlow(root);
    initStickyAtc(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme editor: ξανατρέχει όταν φορτώνει section */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
